import styled from '@emotion/styled'; 
import { ListItemText } from '@mui/material'; 
 
const SelectedListItemText = styled(ListItemText)(({ theme }) => { 
    return ({ 
        color: theme.palette.primary.main 
    }); 
}); 
 
export default SelectedListItemText;